import useSWR from 'swr'
import arcadeApiClient from '../apiClients/arcadeApiClient'

export interface ManagerViewMetricSale {
  kpiGroupName: string
  quantity: number
}

export interface ManagerViewData {
  fulfilledPayout: number
  id: number
  progress: number
  percentageTimeElapsed: number
  progressReason: string
  totalPayout: number
  totalSales: number
  totalSets?: number
  totalTokensAwarded: number
  metricSales?: ManagerViewMetricSale[]
}

const fetcher = async (url: string): Promise<ManagerViewData> => {
  return await arcadeApiClient.get(url).then(res => res.data.game)
}

const useManagerView = (
  gameId?: string | number,
): {
  managerViewData?: ManagerViewData
  isLoading: boolean
  error: Error
} => {
  const {
    data: managerViewData,
    isLoading,
    error,
  } = useSWR(
    gameId ? `/multi_platform/games/${gameId}/manager_view` : null,
    fetcher,
  )

  return { managerViewData, isLoading, error }
}

export default useManagerView
